import React from 'react';
import styles from './PillButton.module.scss';
import Button from '../index';

interface Props {
	onClick: () => void;
	text: string;
	PillComponent: React.ReactElement;
}

const PillButton: React.FC<Props> = ({ onClick, text, PillComponent }) => {
	return (
		<div className={styles.pillButton}>
			{React.cloneElement(PillComponent, {
				...PillComponent.props,
				className: styles.pill,
			})}
			<Button text={text} onClick={onClick} />
		</div>
	);
};

export default PillButton;
